import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import News from '../views/news/News.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  //新闻资讯
  {
    path: '/news',
    name: 'News',
    component: () => import( '../views/news/News.vue')
  },
  //公司业务
  {
    path: '/business',
    name: 'Business',
    component: () => import( '../views/business/Business.vue')
  },
  //公司业务新版
  {
    path: '/businessnew/:type?',
    name: 'Businessnew',
    component: () => import( '../views/business/Businessnew.vue')
  },
  //关于我们
  {
    path: '/aboutUs',
    name: 'AboutUs',
    component: () => import( '../views/aboutUs/AboutUs.vue')
  },
   //联系我们
   {
    path: '/joinUs',
    name: 'JoinUs',
    component: () => import( '../views/joinUs/JoinUs.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
